import React from 'react';

export const pageMeta = {
  "name": "Function Closures",
  "link": "/javascript/functions/closures"
};

export default function JavascriptFunctionsClosures() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Function Closures</h2>
      <p>Route: /javascript/functions/closures</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
